export default __webpack_public_path__ + "static/media/PPFPageLocation.ee2d47c0.webp";